module.exports = __webpack_public_path__ + "static/media/ru_02_online.731406cc.png";